import { render } from "./catBoxBig.vue?vue&type=template&id=27a2fe9f"
import script from "./catBoxBig.vue?vue&type=script&lang=js"
export * from "./catBoxBig.vue?vue&type=script&lang=js"

import "./catBoxBig.vue?vue&type=style&index=0&id=27a2fe9f&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__